import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Importing development configuration
    gamesCasino, // Importing casino games configuration
    profile, // Importing user profile configuration
    providersCasino, // Importing casino providers configuration
} from 'config/config'; // Importing various configurations from config

/**
 * Class representing the view for managing partner product types.
 * @extends JetView
 */
export default class tablePartnersTypeProductView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        var list1 = {
            view: 'dbllist', // Double list view for selecting product types
            id: 'dbllist', // ID for the double list
            list: {
                height: 0, // Height of the list
                scroll: true, // Enable scrolling
            },
            labelLeft: _('Tipo producto no agregados'), // Left label for unadded product types
            labelRight: _('Tipo producto Agregados'), // Right label for added product types
            data: [], // Initial data for the list
        };
        return {
            view: 'form', // Form view
            id: 'f1', // ID for the form
            rows: [
                {
                    view: 'forminput', // Input field for form
                    name: 'access', // Name of the input field
                    body: list1, // Body of the input field containing the double list
                    labelWidth: 140, // Width of the label
                    labelAlign: 'right', // Alignment of the label
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        var values = ''; // Variable to hold selected values
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        var string1 = ''; // String to hold query parameters

        // Event listener for filtering partner providers
        this.on(this.app, 'partnerProvider:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            string1 = ''; // Reset query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            $$('dbllist').$$('left').clearAll(); // Clear left list
            $$('dbllist').setValue([]); // Reset selected values
            webix
                .ajax() // AJAX request to fetch partner product types
                .get(
                    devConfig.geturlApi() + 'PartnersTypeProduct/GetGroupPartnersTypeProduct', // API endpoint
                    string1, // Query parameters
                    {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message('Error! '); // Error message on failure
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var data = JSON.parse(text); // Parse response data
                            if (!data.HasError) {
                                // Check for errors in response
                                $$('dbllist').$$('left').clearAll(); // Clear left list
                                $$('dbllist').setValue([]); // Reset selected values
                                $$('dbllist').parse(data.Data.ExcludedTypeProductList); // Populate left list with excluded product types
                                $$('dbllist').setValue(data.Data.IncludedTypeProductList); // Set selected values to included product types
                                values = data.Data.IncludedTypeProductList; // Store included product types
                            } else {
                                webix.message('Error! '); // Error message on failure
                            }
                        },
                    },
                );
        });

        // Event listener for changes in the double list
        $$('dbllist').attachEvent('onChange', function (id, e, node) {
            var array1 = values.split(','); // Split current values into an array
            var array2 = $$('dbllist').getValue().split(','); // Split selected values into an array
            var arrayAgregados = []; // Array to hold added items
            var arrayEliminados = []; // Array to hold removed items
            array2.forEach(function (obj) {
                var found = array1.find(function (element) {
                    return element == obj; // Check if item was previously included
                });
                if (found != undefined) {
                    // Item was found, do nothing
                } else {
                    arrayAgregados.push(obj); // Item was added
                }
            });
            array1.forEach(function (obj) {
                var found = array2.find(function (element) {
                    return element == obj; // Check if item is still selected
                });
                if (found == undefined) {
                    arrayEliminados.push(obj); // Item was removed
                } else {
                    // Item is still included, do nothing
                }
            });
            values = $$('dbllist').getValue(); // Update stored values
            webix
                .ui({
                    view: 'window', // Create a confirmation window
                    head: {
                        view: 'toolbar', // Toolbar for the window
                        cols: [
                            {
                                view: 'label',
                                label: _('Desea realizar movimiento?'), // Confirmation message
                            },
                        ],
                    },
                    position: 'center', // Center the window
                    modal: true, // Make the window modal
                    body: {
                        view: 'form', // Form inside the window
                        id: 'form', // ID for the form
                        elements: [
                            {
                                view: 'text', // Text input for notes
                                label: _('Observación'), // Label for the input
                                name: 'Note', // Name of the input
                                required: false, // Not required
                                labelWidth: 100, // Width of the label
                            },
                            {
                                cols: [
                                    {
                                        view: 'button', // Cancel button
                                        value: _('Cancelar'), // Button label
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide the window
                                            $$('form').setValues($$('form').getCleanValues()); // Reset form values
                                            webix
                                                .ajax() // AJAX request to refresh data
                                                .get(
                                                    devConfig.geturlApi() +
                                                        'PartnersTypeProduct/GetGroupPartnersTypeProduct', // API endpoint
                                                    string1, // Query parameters
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var data = JSON.parse(text); // Parse response data
                                                            if (!data.HasError) {
                                                                // Check for errors in response
                                                                $$('dbllist').$$('left').clearAll(); // Clear left list
                                                                $$('dbllist').setValue([]); // Reset selected values
                                                                $$('dbllist').parse(data.Data.ExcludedTypeProductList); // Populate left list with excluded product types
                                                                $$('dbllist').setValue(
                                                                    data.Data.IncludedTypeProductList,
                                                                ); // Set selected values to included product types
                                                                values = data.Data.IncludedTypeProductList; // Store included product types
                                                            } else {
                                                                webix.message('Error! '); // Error message on failure
                                                            }
                                                        },
                                                    },
                                                );
                                        },
                                    },
                                    {
                                        view: 'button', // Save button
                                        type: 'form', // Button type
                                        value: _('Guardar'), // Button label
                                        click: function ($e) {
                                            this.getTopParentView().hide(); // Hide the window
                                            var valuesForm = $$('form').getValues(); // Get form values
                                            if ($$('form').validate()) {
                                                // Validate form
                                                var vthis = this; // Reference to the current instance
                                                webix
                                                    .ajax() // AJAX request to save changes
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() +
                                                            'PartnersProviders/SaveGroupPartnersTypeProduct', // API endpoint
                                                        '{"Partner":"' +
                                                            id_partner +
                                                            '","IncludedTypeProductList":"' +
                                                            arrayAgregados +
                                                            '","ExcludedTypeProductList":"' +
                                                            arrayEliminados +
                                                            '","Note":"' +
                                                            valuesForm.Note +
                                                            '"}', // JSON payload
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Error message on failure
                                                                vthis.getTopParentView().hide(); // Hide the window
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var data = JSON.parse(text); // Parse response data
                                                                if (!data.HasError) {
                                                                    // Check for errors in response
                                                                    webix.message(_('Tipo producto Partner Editado')); // Success message
                                                                } else {
                                                                    webix.message(_('Error! ')); // Error message on failure
                                                                }
                                                                vthis.getTopParentView().hide(); // Hide the window
                                                            },
                                                        },
                                                    );
                                            } else {
                                                webix.message({
                                                    // Error message for validation failure
                                                    title: _('¡Error!'),
                                                    type: 'alert-error',
                                                    text: _('Completa los campos...'), // Prompt to complete fields
                                                });
                                            }
                                        },
                                    },
                                ],
                            },
                        ],
                        elementsConfig: {
                            on: {
                                onChange: function () {
                                    this.validate(); // Validate form on change
                                },
                            },
                        },
                    },
                })
                .show(); // Show the confirmation window
        });
    }
}

// FILE DOCUMENTED
